import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

axios.defaults.timeout = 30000

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/aira-aiful`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const airaApi = {
  getAllMembers: (pageid, data) => {
    return instance().get(`/users-aira/${pageid}`, { params: data })
  }
}

export default airaApi



// WEBPACK FOOTER //
// ./src/api/aira-aiful.js